import { ReactNode, useEffect, useState } from "react";
import { CheckCircleOutlined } from "@ant-design/icons";
import { userCancelSubcriptionPayment, userGetSubcriptionPricing } from "../../apiservice/userService";
import {
  Cache_Subscription_Plan_Key,
  getCacheSubscriptionPlan,
} from "../../utils/apiSample/recommendation";
import { IPricingData } from "../../apiservice/userService.type";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../Redux/reduxCustomHook";
import { RootState } from "../../Redux/store";
import { IAuthType } from "../../apiservice/authService.type";
import { Modal, message } from "antd";
import { sampleApiCall } from "../../apiservice/authService";
import { appZIndex } from "../../utils/appconst";
import { formatCurrency } from "../../utils/basic.utils";
import useAuth from "../../hooks/useAuth";
import { formatDateTime } from "../../utils/date.utils";

const SubscriptionPayment = () => {
  const [selectedPlan, setSelectedPlan] = useState(1);
  const [selectedPlanIndex, setSelectedPlanIndex] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [plan, setPlan] = useState<IPricingData[]>([]);
  const navigate = useNavigate();

  const authUserData: IAuthType = useAppSelector(
    (state: RootState) => state?.AuthData
  );

  const [loadAuth, setLoadAuth] = useState(true);

  const authState = useAuth(loadAuth, () => {
    setLoadAuth(false);
  });


  const fetchSubscriptionPlan = async () => {
    try {
      const cacheData = await getCacheSubscriptionPlan();
      if (cacheData?.length > 0) {
        setPlan(cacheData);
        setLoading(false);
      }

      const subPlanData = await userGetSubcriptionPricing();
      if (subPlanData) {
        setPlan(subPlanData?.data);

        localStorage.setItem(
          Cache_Subscription_Plan_Key,
          JSON.stringify(subPlanData?.data)
        );
      } else {
        setError("Category not found");
      }
    } catch (err) {
      setError("Failed to load book data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!authUserData?.data?.credentials?.email) {
      showSignInAlert(
        "Login To Your Account",
        "Please Login to your account to have access to this page.",
        "/auth"
      );
      return;
    }
    fetchSubscriptionPlan();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    navigate(
      "/users/subscription-payment?type=1&id=" +
      plan[selectedPlanIndex].id +
      "&price=" +
      plan[selectedPlanIndex].price +
      "&title=" +
      plan[selectedPlanIndex].title +
      ""
    );
    // if (!stripe || !elements) return;
  };

  const handleCancelSubscription = () => {
    if (authUserData?.data?.credentials?.subscription?.statusId === 3) {
      Modal.info({ title: "Information", content: "Your subscription had already been cancelled" })
      return
    }
    Modal.confirm({
      title: "Are you sure you want to cancel your subscription?",
      content:
        "This action cannot be undone. You will lose access to premium features.",
      okText: "Yes, Cancel It",
      okType: "danger",
      cancelText: "No",
      onOk: async () => {
        try {
          const subCancel = await userCancelSubcriptionPayment({ reason: "Just want to cancel" });;
          alert(
            "An email will be sent to you to confirm subscription cancellation."
          );
          // Optionally refresh user data or redirect
          setTimeout(() => navigate("/users/profile"), 1000);
        } catch (error) {
          alert("Failed to cancel subscription. Please try again.");
        }
      },
    });
  };

  // Show Sign In Alert
  const showSignInAlert = (title: string, content: ReactNode, url: string) => {
    Modal.confirm({
      title,
      content,
      async onOk() {
        navigate(url);
      },
      onCancel() {
        console.log("Cancelled");
      },
      zIndex: appZIndex.modal,
    });
  };

  if (loading) {
    return (
      <div className="p-4 text-center">Loading Subscription details...</div>
    );
  }

  if (error || !plan) {
    return (
      <div className="p-4 text-center text-red-500">
        {error || "Subscription  not found"}
      </div>
    );
  }

  return (
    <div className=" p-6 bg-white dark:bg-stone-800 rounded-xl">
      <h2 className="text-lg font-semibold mb-4 text-gray-900 dark:text-stone-100">
        Select Subscription Plan
      </h2>
      <ul className="space-y-4 text-gray-700 dark:text-stone-300 mb-4">
        <li className="flex items-center gap-2">
          <CheckCircleOutlined className="text-blue-500 dark:text-blue-400" />{" "}
          Unlock all audio
        </li>
        <li className="flex items-center gap-2">
          <CheckCircleOutlined className="text-blue-500 dark:text-blue-400" />{" "}
          Get access to unlimited books
        </li>
        <li className="flex items-center gap-2">
          <CheckCircleOutlined className="text-blue-500 dark:text-blue-400" />{" "}
          Listen to any audio.
        </li>

        <li className="flex items-center gap-2">
          <CheckCircleOutlined className="text-blue-500 dark:text-blue-400" />{" "}
          Unlock all audio
        </li>
        <li className="flex items-center gap-2">
          <CheckCircleOutlined className="text-blue-500 dark:text-blue-400" />{" "}
          Get access to unlimited books
        </li>
        <li className="flex items-center gap-2">
          <CheckCircleOutlined className="text-blue-500 dark:text-blue-400" />{" "}
          Listen to any audio.
        </li>
      </ul>

      {authUserData?.data?.credentials?.hasValidSubscription ? (
        <>
          <div className="grid  gap-3 mb-6 mt-8">
            <h2 className="text-gray-500 dark:text-stone-400 font-bold text-lg mb-4">
              Cancel My Subscription
            </h2>

            <p className="text-gray-500 dark:text-stone-400">
              You still have an active subscription that will expired by {formatDateTime(authUserData?.data?.credentials?.subscription?.nextBillingDate || Date.now())}
            </p>



            {authUserData?.data?.credentials?.subscription?.statusId === 3 ? <p className="text-gray-500 dark:text-stone-400">
              Your subscription plan have been cancelled already.
            </p> : null}


            {authUserData?.data?.credentials?.subscription?.statusId === 1 ? <p className="text-gray-500 dark:text-stone-400">
              Your subscription will auto-renewed on  {formatDateTime(authUserData?.data?.credentials?.subscription?.nextBillingDate || Date.now())}
            </p> : null}


            <button

              type="button"
              onClick={handleCancelSubscription}
              className="w-full bg-blue-800 hover:bg-blue-700 dark:hover:bg-blue-600 text-white py-3 rounded-md text-lg font-medium"
            >
              Cancel Subscription
            </button>
          </div>
        </>
      ) : (
        <>
          {" "}
          <div className="grid gap-3 mb-6">
            {(plan || []).map((plan, index) => {

              return (
                <div
                  key={plan.id}
                  className={`p-4 rounded-md mb-4 cursor-pointer ${selectedPlan === plan.id
                    ? "bg-blue-300 text-blue-800 border-amber-300 dark:bg-blue-700 dark:text-blue-100 dark:border-amber-500 border-4"
                    : "bg-gray-100 dark:bg-stone-700 text-gray-900 dark:text-stone-100"
                    }`}
                  onClick={() => {
                    setSelectedPlan(plan.id);
                    setSelectedPlanIndex(index);
                  }}
                >
                  <div className="flex">
                    {/* Left */}
                    <div className="basis-3/5">
                      <div className="flex justify-between text-sm font-medium mb-2">
                        <span>{plan?.title}</span>

                        {Number(plan.percentageOff) > 0 && (
                          <span className="bg-red-500 text-white text-xs px-2 py-1 rounded-full">
                            {plan.percentageOff}% OFF
                          </span>
                        )}
                      </div>

                      <div className="text-sm font-medium mb-2">
                        <span className="font-semibold text-2xl">
                          {plan?.oldPrice && (
                            <s className="text-gray-900 dark:text-stone-100">
                              {formatCurrency(plan?.oldPrice)}
                            </s>
                          )}
                          &nbsp;
                          {formatCurrency(plan?.price)}
                        </span>
                      </div>
                    </div>

                    {/* Right */}
                    <div className="basis-2/5">
                      <div className="flex justify-end text-sm font-medium mb-2">
                        <span className="font-semibold text-2xl text-gray-900 dark:text-stone-100">
                          {plan.id === 1
                            ? formatCurrency(plan?.price / 30)
                            : plan.id === 2
                              ? formatCurrency(plan?.price / 365)
                              : formatCurrency(plan?.price)}
                        </span>
                      </div>
                      <div className="flex justify-end text-sm font-medium">
                        <span>Per Day</span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <form onSubmit={handleSubmit} className="mb-4">
            <button
              type="submit"
              className="w-full bg-blue-800 hover:bg-blue-700 dark:hover:bg-blue-600 text-white py-3 rounded-md text-lg font-medium"
            >
              Continue
            </button>
          </form>
          <p className="text-xs text-gray-500 dark:text-stone-400 text-center">
            Cancellation Policy: Cancel at any time.
          </p>
        </>
      )}
    </div>
  );
};

export default SubscriptionPayment;
